import PlusCircle from './PlusCircleIcon.svg';

type ImageProps = React.JSX.IntrinsicElements['div'] & {
  width?: string;
  alt?: string;
};

export const PlusCircleIcon = ({ width = '20px', alt = 'Plus circle icon', ...props }: ImageProps) => (
  <div {...props}>
    <img src={PlusCircle} width={width} alt={alt} />
  </div>
);
